var Handlebars = require("/home/jenkins/agent/workspace/hybrid-accsts-task-release/hybrid-accsts-jsclient/target/toolchain/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, alias3="function", alias4=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"code\">"
    + alias4(((helper = (helper = lookupProperty(helpers,"text") || (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"text","hash":{},"data":data,"loc":{"start":{"line":1,"column":18},"end":{"line":1,"column":26}}}) : helper)))
    + "</div>\n<div class=\"column-indicator\">"
    + alias4(((helper = (helper = lookupProperty(helpers,"columnIndicator") || (depth0 != null ? lookupProperty(depth0,"columnIndicator") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"columnIndicator","hash":{},"data":data,"loc":{"start":{"line":2,"column":30},"end":{"line":2,"column":49}}}) : helper)))
    + "</div>\n<div class=\"error\">"
    + alias4(((helper = (helper = lookupProperty(helpers,"error") || (depth0 != null ? lookupProperty(depth0,"error") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"error","hash":{},"data":data,"loc":{"start":{"line":3,"column":19},"end":{"line":3,"column":28}}}) : helper)))
    + "</div>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./test/it/lib/templates/line_view.hbs
// module id = 1608
// module chunks = 0